var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPcidsssaqdLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4827_452)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 90,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.9998,
    cy: 89.9998,
    r: 87.3333,
    fill: "#225E63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.921 104.255L154.667 101.807L152.15 96.1996C150.302 98.5295 148.455 101.531 146.921 104.255ZM144.287 78.6271L129.11 44.6665L18 50.9847L48.7854 135.333L108.036 116.576C104.262 111.126 102.886 104.65 107.25 101.491C112.125 97.9372 119.478 102.044 124.157 107.849C128.678 100.267 141.377 82.6154 144.287 78.6271Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.667 69.233C130.262 69.233 134 65.6911 134 61.2833C134 56.8755 130.262 53.3335 125.667 53.3335C121.072 53.3335 117.333 56.8755 117.333 61.2833C117.333 65.6517 121.072 69.233 125.667 69.233ZM118.852 72.6569H132.481V108.667H118.852V72.6569Z",
    fill: "#225E63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.689 83.0676C111.806 83.1065 111.884 83.0676 111.884 82.9508V73.922C111.884 73.8052 111.806 73.6885 111.689 73.6106C111.689 73.6106 109.889 72.4431 104.411 72.1317C104.137 71.9761 99.3239 71.9372 98.0326 72.1317C78.0769 73.7274 77.3335 88.0879 77.3335 88.7106V92.2132C77.3335 92.6413 77.3335 107.313 98.0326 108.597C100.067 108.753 104.019 108.597 104.411 108.597C109.184 108.597 112.471 107.158 112.471 107.158C112.589 107.119 112.667 107.002 112.667 106.885V98.44C112.667 98.3233 112.589 98.2843 112.51 98.3622C112.51 98.3622 111.023 99.5297 104.528 100.191C102.689 100.386 101.789 100.308 101.124 100.191C91.8894 98.6346 91.459 91.9408 91.459 91.9408C91.459 91.824 91.4199 91.6294 91.4199 91.5516V88.983C91.4199 88.8663 91.4199 88.6717 91.459 88.5939C91.459 88.5939 92.0851 81.3941 101.124 80.6158H104.528C108.48 81.1217 111.689 83.0676 111.689 83.0676Z",
    fill: "#225E63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.124 126C127.225 126 128.09 126 129.505 125.37C134.381 122.811 150.855 82.5306 168.234 70.1276C168.352 70.0489 168.47 69.9308 168.549 69.8127C168.667 69.6552 168.667 69.4977 168.667 69.4977C168.667 69.4977 168.667 68.6708 166.111 68.6708C150.659 68.2377 134.577 100.722 126.124 113.558C126.006 113.715 125.456 113.558 125.456 113.558C125.456 113.558 119.794 106.864 114.879 104.305C114.761 104.265 114.211 104.068 113.621 104.108C113.228 104.108 110.947 104.58 109.886 105.683C108.627 107.021 108.667 107.77 108.667 109.384C108.667 109.502 108.745 110.053 108.903 110.329C110.121 112.455 115.587 120.015 120.108 124.189C120.777 124.7 121.838 126 126.124 126Z",
    fill: "#2BBC5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3335 108.47C39.3335 108.588 39.4119 108.667 39.5296 108.667H52.9021C53.0197 108.667 53.0982 108.588 53.0982 108.47V98.0328C53.0982 97.9151 53.1766 97.8366 53.2942 97.8366C53.2942 97.8366 74.6668 99.3669 74.6668 85.0449C74.6668 73.7049 61.2551 72.4885 56.8629 72.6847C56.7844 72.6847 39.5296 72.6847 39.5296 72.6847C39.4119 72.6847 39.3335 72.7632 39.3335 72.8809V108.47ZM52.8629 89.8712V80.4932H56.157C56.157 80.4932 60.9022 80.6894 61.2943 83.9462C61.3727 84.1816 61.3727 85.7904 61.2943 85.8689C60.6669 89.675 56.5491 89.8712 56.5491 89.8712H52.8629Z",
    fill: "#225E63"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4827_452"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcidsssaqdLogo);
export default __webpack_public_path__ + "static/media/pcidsssaqd-logo.f862c7bb.svg";
export { ForwardRef as ReactComponent };